"use strict";

var _classCallCheck = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownRegionError = exports.UnknownStageError = exports.UnknownRbiMethodError = exports.UnknownRbiMessageQueueError = exports.UnknownBrandError = exports.PosVendorMismatchError = exports.MissingRequiredParametersError = exports.EnumMemberNotFoundError = exports.CastError = exports.BrandNotSupportedError = exports.RbiError = void 0;

var http_status_codes_1 = __importDefault(require("http-status-codes")); // all error will inherit from RbiError, which inherits from base Error


var RbiError = /*#__PURE__*/function (_Error) {
  _inherits(RbiError, _Error);

  var _super = _createSuper(RbiError);

  function RbiError(message) {
    var _this;

    _classCallCheck(this, RbiError);

    _this = _super.call(this, message); // by default, all errors will have a 500 code
    // in each error, this can be overridden as shown below

    _this.statusCode = http_status_codes_1.default.INTERNAL_SERVER_ERROR;
    return _this;
  }

  return RbiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.RbiError = RbiError;
/**
 * Place generic, non-application specific errors here
 * For ease of maintenance, keep all errors alphabetical and self-documenting
 */

var BrandNotSupportedError = /*#__PURE__*/function (_RbiError) {
  _inherits(BrandNotSupportedError, _RbiError);

  var _super2 = _createSuper(BrandNotSupportedError);

  function BrandNotSupportedError(brand) {
    _classCallCheck(this, BrandNotSupportedError);

    return _super2.call(this, "This functionality is not supported for Brand '".concat(brand, "'."));
  }

  return BrandNotSupportedError;
}(RbiError);

exports.BrandNotSupportedError = BrandNotSupportedError;

var CastError = /*#__PURE__*/function (_RbiError2) {
  _inherits(CastError, _RbiError2);

  var _super3 = _createSuper(CastError);

  function CastError(errors, data) {
    var _this2;

    _classCallCheck(this, CastError);

    _this2 = _super3.call(this, "Cast failed: ".concat(errors.join(', ')));
    _this2.errors = errors;
    _this2.data = data;
    _this2.statusCode = http_status_codes_1.default.BAD_REQUEST;
    return _this2;
  }

  return CastError;
}(RbiError);

exports.CastError = CastError;

var EnumMemberNotFoundError = /*#__PURE__*/function (_RbiError3) {
  _inherits(EnumMemberNotFoundError, _RbiError3);

  var _super4 = _createSuper(EnumMemberNotFoundError);

  function EnumMemberNotFoundError(receivedValue, expectedValues) {
    var _this3;

    _classCallCheck(this, EnumMemberNotFoundError);

    _this3 = _super4.call(this, "Unknown enum value received: got ".concat(receivedValue, ", expected one of ").concat(expectedValues.join(' | ')));
    _this3.statusCode = http_status_codes_1.default.NOT_FOUND;
    return _this3;
  }

  return EnumMemberNotFoundError;
}(RbiError);

exports.EnumMemberNotFoundError = EnumMemberNotFoundError;

var MissingRequiredParametersError = /*#__PURE__*/function (_RbiError4) {
  _inherits(MissingRequiredParametersError, _RbiError4);

  var _super5 = _createSuper(MissingRequiredParametersError);

  function MissingRequiredParametersError() {
    var _this4;

    _classCallCheck(this, MissingRequiredParametersError);

    for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
      parameters[_key] = arguments[_key];
    }

    _this4 = _super5.call(this, "Missing required parameters.  ".concat(parameters.join()).trimRight());
    _this4.statusCode = http_status_codes_1.default.BAD_REQUEST;
    return _this4;
  }

  return MissingRequiredParametersError;
}(RbiError);

exports.MissingRequiredParametersError = MissingRequiredParametersError;

var PosVendorMismatchError = /*#__PURE__*/function (_RbiError5) {
  _inherits(PosVendorMismatchError, _RbiError5);

  var _super6 = _createSuper(PosVendorMismatchError);

  function PosVendorMismatchError(value) {
    var _this5;

    _classCallCheck(this, PosVendorMismatchError);

    for (var _len2 = arguments.length, expectations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      expectations[_key2 - 1] = arguments[_key2];
    }

    _this5 = _super6.call(this, "The POS Vendor ".concat(value, " does not match expectations ").concat(expectations.join(), "."));
    _this5.statusCode = http_status_codes_1.default.BAD_REQUEST;
    return _this5;
  }

  return PosVendorMismatchError;
}(RbiError);

exports.PosVendorMismatchError = PosVendorMismatchError;

var UnknownBrandError = /*#__PURE__*/function (_RbiError6) {
  _inherits(UnknownBrandError, _RbiError6);

  var _super7 = _createSuper(UnknownBrandError);

  function UnknownBrandError(brand) {
    _classCallCheck(this, UnknownBrandError);

    return _super7.call(this, "Brand '".concat(brand, "' is not known or not configured."));
  }

  return UnknownBrandError;
}(RbiError);

exports.UnknownBrandError = UnknownBrandError;

var UnknownRbiMessageQueueError = /*#__PURE__*/function (_RbiError7) {
  _inherits(UnknownRbiMessageQueueError, _RbiError7);

  var _super8 = _createSuper(UnknownRbiMessageQueueError);

  function UnknownRbiMessageQueueError() {
    _classCallCheck(this, UnknownRbiMessageQueueError);

    for (var _len3 = arguments.length, parameters = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      parameters[_key3] = arguments[_key3];
    }

    return _super8.call(this, "No RBI message queue could be found using identifiers: ".concat(parameters.join()));
  }

  return UnknownRbiMessageQueueError;
}(RbiError);

exports.UnknownRbiMessageQueueError = UnknownRbiMessageQueueError;

var UnknownRbiMethodError = /*#__PURE__*/function (_RbiError8) {
  _inherits(UnknownRbiMethodError, _RbiError8);

  var _super9 = _createSuper(UnknownRbiMethodError);

  function UnknownRbiMethodError() {
    _classCallCheck(this, UnknownRbiMethodError);

    for (var _len4 = arguments.length, parameters = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      parameters[_key4] = arguments[_key4];
    }

    return _super9.call(this, "No RBI method could be found using identifiers: ".concat(parameters.join()));
  }

  return UnknownRbiMethodError;
}(RbiError);

exports.UnknownRbiMethodError = UnknownRbiMethodError;

var UnknownStageError = /*#__PURE__*/function (_RbiError9) {
  _inherits(UnknownStageError, _RbiError9);

  var _super10 = _createSuper(UnknownStageError);

  function UnknownStageError(stage) {
    _classCallCheck(this, UnknownStageError);

    return _super10.call(this, "Stage '".concat(stage, "' is not known or not configured."));
  }

  return UnknownStageError;
}(RbiError);

exports.UnknownStageError = UnknownStageError;

var UnknownRegionError = /*#__PURE__*/function (_RbiError10) {
  _inherits(UnknownRegionError, _RbiError10);

  var _super11 = _createSuper(UnknownRegionError);

  function UnknownRegionError(region) {
    _classCallCheck(this, UnknownRegionError);

    return _super11.call(this, "Region '".concat(region, "' is not known or not configured."));
  }

  return UnknownRegionError;
}(RbiError);

exports.UnknownRegionError = UnknownRegionError;